(function () {
  const MAX = 4;
  const MSG = 'Maximal 4 Stück pro Bestellung möglich.';

  // ── Fehlermeldung ──────────────────────────────────────────────
  function showError(input) {
    const component = input.closest('cart-quantity-selector-component');
    if (!component) return;

    let err = component.__cartErr;
    if (!err || !err.isConnected) {
      err = document.createElement('span');
      err.style.cssText = [
        'display:block',
        'color:#c0392b',
        'font-size:13px',
        'margin-top:6px',
        'font-family:inherit',
        'transition:opacity .3s',
      ].join(';');
      err.textContent = MSG;
      component.insertAdjacentElement('afterend', err);
      component.__cartErr = err;
    }
    err.style.opacity = '1';
    clearTimeout(component.__cartErrT);
    component.__cartErrT = setTimeout(() => (err.style.opacity = '0'), 4000);
  }

  // ── Wert klemmen (bei Direkteingabe / Plus-Button) ─────────────
  function enforce(input) {
    const val = parseInt(input.value, 10);
    if (!isNaN(val) && val > MAX) {
      input.value = MAX;
      showError(input);
    }
  }

  // ── Plus-Button blockieren (delegiert auf document) ────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('cart-quantity-selector-component button[name="plus"]');
    if (!btn) return;
    const input = btn.closest('cart-quantity-selector-component')
                     ?.querySelector('input[name="updates[]"]');
    if (!input) return;
    if (parseInt(input.value, 10) >= MAX) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(input);
    }
  }, true);

  // ── Direkteingabe abfangen (delegiert auf document) ───────────
  document.addEventListener('input', function (e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name !== 'updates[]') return;
    if (!input.closest('cart-quantity-selector-component')) return;
    enforce(input);
  });

  // ── Startwert korrigieren + Horizon cart update triggern ───────
  // Wenn z.B. 5 Stück im Cart landen: Wert auf 4 setzen UND
  // Horizons blur-Handler auslösen, damit /cart/change.js aufgerufen
  // wird und Summe serverseitig korrigiert wird.
  function syncMax() {
    document
      .querySelectorAll('cart-quantity-selector-component input[name="updates[]"]')
      .forEach(function (input) {
        input.setAttribute('max', MAX);

        const val = parseInt(input.value, 10);
        if (isNaN(val) || val <= MAX) return;

        // Wert korrigieren
        input.value = MAX;

        // Horizon's setQuantity via blur triggern → updated /cart/change.js
        // Kleines Delay damit Horizon bereits initialisiert ist
        if (!input.__correcting) {
          input.__correcting = true;
          setTimeout(function () {
            input.dispatchEvent(new Event('blur', { bubbles: true }));
            input.__correcting = false;
          }, 80);
        }
      });
  }

  syncMax();
  new MutationObserver(syncMax).observe(document.body, { childList: true, subtree: true });
})();